import { staticText } from 'utils/staticText';
import { EmailTypoSuggestionStaticText } from '$/components/EmailTypoSuggestion/i18n';

export const LoginTermsStaticText = staticText({
  loginTermsAndConditions: {
    _: '[missing data]',
    'en-sg': (
      <>
        By continuing, you agree to SingSaver’s{' '}
        <a
          href="https://www.singsaver.com.sg/page/singsaver-terms"
          className="text-primary-700"
        >
          Terms & Conditions
        </a>{' '}
        and{' '}
        <a
          href="https://www.singsaver.com.sg/page/singsaver-privacy-policy"
          className="text-primary-700"
        >
          Privacy Policy
        </a>
      </>
    ),
    'en-hk': (
      <>
        By continuing, you agree to MoneyHero’s{' '}
        <a
          href="https://www.moneyhero.com.hk/en/terms"
          className="text-primary-700"
        >
          Terms & Conditions
        </a>{' '}
        and{' '}
        <a
          href="https://www.moneyhero.com.hk/en/privacy-policy"
          className="text-primary-700"
        >
          Privacy Policy
        </a>
      </>
    ),
    'zh-hk': (
      <>
        登入或註冊即表示您同意MoneyHero及其關聯公司之
        <a
          href="https://www.moneyhero.com.hk/zh/terms"
          className="text-primary-700"
        >
          條款及細則
        </a>
        和
        <a
          href="https://www.moneyhero.com.hk/zh/privacy-policy"
          className="text-primary-700"
        >
          個人私隱政策
        </a>
        。
      </>
    ),
    'zh-tw': (
      <>
        登入或註冊即表示您同意Money101之
        <a
          className="underline"
          href="https://www.money101.com.tw/pages/money101%E6%9C%8D%E5%8B%99%E6%A2%9D%E6%AC%BE"
        >
          條款及細則
        </a>
        和
        <a
          className="underline"
          href="https://www.money101.com.tw/pages/money101%E9%9A%B1%E7%A7%81%E6%94%BF%E7%AD%96"
        >
          個人私隱政策
        </a>
        。
      </>
    ),
    'en-ph': (
      <>
        By continuing, you agree to MoneyMax&apos;s{' '}
        <a
          href="https://www.moneymax.ph/page/terms-and-conditions"
          className="text-primary-700"
        >
          Terms & Conditions
        </a>{' '}
        and{' '}
        <a
          href="https://www.moneymax.ph/page/privacy-policy"
          className="text-primary-700"
        >
          Privacy Policy
        </a>
      </>
    ),
  },
  marketingConsent: {
    _: '[missing data]',
    'en-sg': (
      <>
        I consent to receiving marketing materials from SingSaver Pte Ltd /
        SingSaver Insurance Brokers Pte Ltd about their products, services,
        offers & events by email, phone call, IM or text as per their{' '}
        <a
          href="https://www.singsaver.com.sg/page/singsaver-privacy-policy"
          className="text-primary-700"
        >
          Privacy Policy
        </a>
      </>
    ),
    'en-hk': (
      <>
        I consent to receiving marketing materials from MoneyHero Global Limited
        / MoneyHero Insurance Brokers Limited about their products, services,
        offers & events by email, phone call, IM or text using the personal data
        I have provided as per their{' '}
        <a
          href="https://www.moneyhero.com.hk/en/page/moneyhero-privacy-policy"
          className="text-primary-700"
        >
          Privacy Policy
        </a>
        . Opt-out by email to{' '}
        <a href="mailto:support@moneyhero.com.hk" className="text-primary-700">
          support@moneyhero.com.hk
        </a>
      </>
    ),
    'zh-hk': (
      <>
        我同意透過電子郵件、電話、IM或簡訊接收MoneyHero Global Limited /
        MoneyHero Insurance Brokers Limited
        有關其產品、服務、優惠及活動的營銷資料、並使用我根據其
        <a
          href="https://www.moneyhero.com.hk/zh/page/moneyhero-privacy-policy"
          className="text-primary-700"
        >
          隱私政策
        </a>
        所提供的個人資料。選擇退出、請發送電子郵件至
        <a href="mailto:support@moneyhero.com.hk" className="text-primary-700">
          support@moneyhero.com.hk
        </a>
      </>
    ),
    'zh-tw': (
      <>
        我同意透過電子郵件接收Money101
        有關其產品、服務、優惠及活動的營銷資料、並使用我根據其
        <a
          className="underline text-primary-700"
          href="https://www.money101.com.tw/pages/money101%E9%9A%B1%E7%A7%81%E6%94%BF%E7%AD%96"
        >
          隱私政策
        </a>
        所提供的個人資料。選擇退出、請發送電子郵件至
        <a
          className="underline text-primary-700"
          href="mailto:support@money101.com.tw"
        >
          support@money101.com.tw
        </a>
      </>
    ),
    'en-ph': (
      <>
        I consent to receiving marketing materials from Moneyguru Philippines
        Corporation about their products, services, offers & events by email,
        phone call, IM or text using the personal data I have provided as per
        their{' '}
        <a
          href="https://www.moneymax.ph/page/privacy-policy"
          className="text-primary-700"
        >
          Privacy Policy
        </a>
      </>
    ),
  },
});

export const LoginStaticText = staticText({
  continueWithEmail: {
    _: 'Continue with Email',
    zh: '登入/註冊',
  },
  continueWithGoogle: {
    _: 'Continue with Google',
    zh: '使用Google帳戶繼續',
  },
  or: {
    _: 'or',
    zh: '或',
  },
  enterYourEmail: {
    _: 'Enter your Email',
    zh: '請輸入您的電郵地址',
  },
  incorrectEmail: {
    _: 'Incorrect email address entered.',
    zh: '請輸入正確的信件格式',
  },
  resendEmail: {
    _: 'Resend',
    zh: '重寄驗證信',
  },
  ...LoginTermsStaticText,
  ...EmailTypoSuggestionStaticText,
});

export const LoginFormStaticText = staticText({
  loginHeader: {
    _: 'Log in or sign up',
    zh: '立即登入或註冊',
  },
  magicLinkHeader: {
    _: 'Check your email - We sent you a magic link to log in.',
    zh: '我們已將驗證信寄送至您的郵件地址，請點擊信內連結以進行登入',
  },
  magicLinkSent: {
    _: 'We just sent to ${email}',
    zh: '驗證信已寄送至: ${email}',
  },
  reenterYourEmail: {
    _: ' Re-enter your e-mail',
    zh: '重新輸入電郵地址',
  },
  ...LoginStaticText,
});

const currentYear = new Date().getFullYear();

export const LoginPageStaticText = staticText({
  loginTitle: {
    _: 'Login or Signup',
    zh: '立即登入或註冊',
  },
  loginFooter: {
    _: '[missing data]',
    'en-sg': `© 2015-${currentYear} SingSaver Pte Ltd. All rights reserved.`,
    'en-hk': `© 2013 - ${currentYear} MoneyHero Global Limited (registered in Hong Kong under company number 1864714) (“MHGL”). All rights reserved.`,
    'zh-hk': `© 2013 - ${currentYear} MoneyHero Global Limited（於香港註冊，公司編號為 1864714）(“MHGL”)。版權所有。`,
    'zh-tw': (
      <>
        © 2014 - {currentYear} Money101 Limited.
        理財一零一有限公司版權所有。本公司不提供代辦服務，使用此網站即視為同意我們的
        <a
          className="underline"
          href="https://www.money101.com.tw/pages/money101%E6%9C%8D%E5%8B%99%E6%A2%9D%E6%AC%BE"
        >
          服務條款
        </a>
        及
        <a
          className="underline"
          href="https://www.money101.com.tw/pages/money101%E9%9A%B1%E7%A7%81%E6%94%BF%E7%AD%96"
        >
          隱私政策
        </a>
        。
      </>
    ),
    'en-ph': `© ${currentYear} Moneyguru Philippines Corporation. All rights reserved.`,
  },
  ...LoginFormStaticText,
});
